import moment from 'moment-jalaali'
import momentTimezone from 'moment-timezone'

export const feedbackNumber = value => String(value).replace(/\d/g, digit => '۰۱۲۳۴۵۶۷۸۹'[digit])

// Match session cards: Persian calendar, using the profile's timezone first.
export function feedbackSessionTime(value, timezone = 'UTC') {
  if (!value || !momentTimezone(value, momentTimezone.ISO_8601, true).isValid()) return null
  const zone = momentTimezone.tz.zone(timezone) ? timezone : 'UTC'
  const local = momentTimezone(value).tz(zone)
  const calendar = moment(local.format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss').locale('fa')
  return {
    date: feedbackNumber(calendar.format('jYYYY/jMM/jDD')),
    shortDate: feedbackNumber(calendar.format('jYYYY/jMM/jDD')),
    time: feedbackNumber(local.format('HH:mm'))
  }
}

export function feedbackSessionLabel(value, timezone) {
  const scheduled = feedbackSessionTime(value, timezone)
  return scheduled ? `${scheduled.shortDate}، ${scheduled.time}` : 'زمان جلسه ثبت نشده'
}
